import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  IT_SERVICES_DOMAIN_INTRO,
  IT_SERVICES_GROUPS,
  IT_SERVICES_USE_CASES_SEO,
  IT_SERVICES_DOMAIN_FAQS,
  IT_SERVICES_ITEM_LIST_JSONLD,
  IT_SERVICES_BREADCRUMB_JSONLD,
  IT_SERVICES_WEBPAGE_JSONLD,
  IT_SERVICES_FAQ_JSONLD,
} from "../../data/rpa/it-technology-services-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = IT_SERVICES_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function ITServicesRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? IT_SERVICES_GROUPS
      : IT_SERVICES_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={IT_SERVICES_DOMAIN_INTRO}
        domainSlug="it-technology-services-domain"
        basePath="/rpa-use-cases"
        useCaseCount={IT_SERVICES_USE_CASES_SEO.length}
        groupCount={IT_SERVICES_GROUPS.length}
        itemListJsonLd={IT_SERVICES_ITEM_LIST_JSONLD}
        faqJsonLd={IT_SERVICES_FAQ_JSONLD}
        breadcrumbJsonLd={IT_SERVICES_BREADCRUMB_JSONLD}
        webPageJsonLd={IT_SERVICES_WEBPAGE_JSONLD}
        keywords="IT & Technology Services automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{IT_SERVICES_DOMAIN_INTRO.title}</h1>
          {IT_SERVICES_DOMAIN_INTRO.content ? <p>{IT_SERVICES_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={IT_SERVICES_USE_CASES_SEO}
        groups={IT_SERVICES_GROUPS}
        heading="IT & Technology Services Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={IT_SERVICES_DOMAIN_INTRO.title}
        domainFaqs={IT_SERVICES_DOMAIN_FAQS}
        useCases={IT_SERVICES_USE_CASES_SEO}
      />
    </div>
  );
}

